import React, {useState} from 'react';
import ModalContainer from '../../uiToolkit/ModalContainer';
import TextInput2 from '../../uiToolkit/Inputs/TextInput2/TextInput2';
import Button from '../../uiToolkit/Buttons/Button';
import {LearnerGroup} from '../../data/models/Groups/LearnerGroup';
import {learnerGroupsText} from './learnerGroupsText';
import styles from './GroupFormModal.module.css';

interface Props {
  group?: LearnerGroup;
  isLoading: boolean;
  onSubmit: (name: string, description: string | null) => void;
  onClose: () => void;
}

const NAME_MAX_LENGTH = 60;
const DESCRIPTION_MAX_LENGTH = 120;

const GroupFormModal = React.memo(
  ({group, isLoading, onSubmit, onClose}: Props) => {
    const [name, setName] = useState(group?.name ?? '');
    const [description, setDescription] = useState(group?.description ?? '');

    return (
      <ModalContainer onClose={onClose} className={styles.modal}>
        <div className={styles.content}>
          <h3 className={styles.title}>
            {group
              ? learnerGroupsText.editGroup
              : learnerGroupsText.createGroup}
          </h3>
          <TextInput2
            uiType="minimal"
            label={learnerGroupsText.groupName}
            placeholder={learnerGroupsText.groupNamePlaceholder}
            value={name}
            onChange={setName}
            maxCharacters={NAME_MAX_LENGTH}
            isMandatory
          />
          <TextInput2
            uiType="minimal"
            label={learnerGroupsText.groupDescription}
            placeholder={learnerGroupsText.groupDescriptionPlaceholder}
            value={description}
            onChange={setDescription}
            maxCharacters={DESCRIPTION_MAX_LENGTH}
          />
          <div className={styles.actions}>
            <Button
              title={learnerGroupsText.cancel}
              uiType="text"
              onClick={onClose}
            />
            <Button
              title={learnerGroupsText.save}
              disabled={!name.trim()}
              isLoading={isLoading}
              onClick={() => onSubmit(name.trim(), description.trim() || null)}
            />
          </div>
        </div>
      </ModalContainer>
    );
  },
);

export default GroupFormModal;
